export default __webpack_public_path__ + "static/SequenceMenu_Hover-4a70ce553a9e8ded0bf112f4ac9583da.png";